import React from "react";
import MatchupView from "../../draft/matchup/MatchupView";

export default function (props) {
  console.log("Matchup props:", props);
  return <MatchupView {...props} />;
}
